/**
 * Role-Based Access Control (RBAC) definitions for the Support Portal.
 * Permissions are now fetched from the API, but we keep defaults for fallback.
 */

import type { RolePermissions } from '@/api/types';

// Re-export the RolePermissions type for convenience
export type { RolePermissions };

// Alias for backward compatibility
export type Permission = RolePermissions;

/**
 * Default permissions when no role is assigned or permissions not available
 */
export const DEFAULT_PERMISSIONS: RolePermissions = {
  canView: false,
  canEdit: false,
  canDelete: false,
  canViewDlq: false,
  canManageDlq: false,
  canManageUsers: false,
  canManageCompany: false,
  canManageSystem: false,
  canAuditTrail: false,
  canViewIntegrationAudit: false,
  canManagePolling: false,
  canViewDataHub: false,
  canManageDataHub: false,
  canViewDocuments: false,
  canReviewDocuments: false,
  canManageDocuments: false,
};

/**
 * Get permissions from a RolePermissions object, or return defaults
 */
export function getPermissions(permissions: RolePermissions | null): RolePermissions {
  if (!permissions) {
    return DEFAULT_PERMISSIONS;
  }
  return permissions;
}
